/**
 *
 * @param mapId
 * @param isModified
 * @param folderStructure
 * @returns [obj]
 */
export const setMapModified = (mapId, isModified, folderStructure) => {
    folderStructure.forEach((folder) => {
        folder.codeNames.forEach((map) => {
            if(map.id === mapId) map.swModified = isModified;
        })
    });

    return folderStructure;
};

export const toggleMapFavourited = (mapId, folderStructure) => {
    folderStructure.forEach((folder) => {
        folder.codeNames.forEach((map) => {
            if(map.id === mapId) map.favourited = !map.favourited;
        })
    });

    return folderStructure;
};